<template>
    <el-amap vid="amapDemo" :zoom="zoom" :center="center" :scrollWheel="scrollWheel">
        <el-amap-marker  v-for="(marker,index) in markers" :position="marker.position" :key="index">
        </el-amap-marker>
        <el-amap-info-window v-for="(window,index) in windows" :position="window.position" :content="window.content" :open="window.open" :key="index"></el-amap-info-window>
    </el-amap>
</template>

<script>
    export default {
        data() {
            return {
                isTransparent: false,
                zoom: 14,
                center: [114.174012,22.31694],
                scrollWheel: false,
                markers: [],
                windows: [
                    {
                        content:'iFREE Group (HK) Ltd, Suite 1906, 19/F, Mira Place Tower A, 132 Nathan Road, Tsimshatsui, Kowloon,Hong Kong.+852 2473 8888，ask@ifreegroup.com',
                        position: [114.174012,22.31694]
                    }
                ]
            }
        },
        mounted() {
            // 姑且N为2
            // 这样地图上就添加了两个人
            this.markers = [
                {
                    position: [114.174012,22.31694]
                }
            ]
        }
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// secont.vue?7cafd4ae